import { StyledHeading } from '../../Typography/Heading/Heading.mjs';
import { StyledVideoControlIconButtonContainer } from '../VideoControlIconButton/VideoControlIconButton.styles.mjs';
import styled from 'styled-components';

const StyledContainer = styled.div `
  display: grid;
  aspect-ratio: 16 / 9;

  ${StyledVideoControlIconButtonContainer} {
    grid-area: 1 / 1;
    justify-self: center;
    align-self: center;
  }
`;
const StyledHeadingContainer = styled.div `
  grid-area: 1 / 1;
  justify-self: flex-start;
  align-self: flex-end;
  padding: 0.375rem 0.625rem;

  ${StyledHeading} {
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    margin: 0;
    color: ${props => props.theme.colors.videoHeroTextColor};
  }

  @media screen and (min-width: ${props => props.theme.breakpoints.md}) {
    padding: 1rem 1.5rem;

    ${StyledHeading} {
      font-size: 1.75rem;
      line-height: 2.25rem;
    }
  }
`;
const StyledImage = styled.img `
  grid-area: 1 / 1;
  width: 100%;
  height: 100%;
  object-fit: cover;
`;
const StyledOverlay = styled.div `
  grid-area: 1 / 1;
  width: 100%;
  height: 100%;
  background: ${props => props.theme.gradients.heroImageOverlay};
`;

export { StyledContainer, StyledHeadingContainer, StyledImage, StyledOverlay };
//# sourceMappingURL=VideoHeroCard.styles.mjs.map
